<template>
    <v-form
            ref="form"
            v-model="characteristicsStep"
            lazy-validation
    >
        <v-card class="mb-10 border-transparent px-8 min-card-height" outlined>
        <div>
            <v-card-title class="py-4  subtitle-2 ">{{$t('characteristics')}}</v-card-title>
            <product-attributes
                    :product-attributes="productAttributes"
                    :initial-attributes="initialAttributes"
                    @attribute-change="attributesChange"
            ></product-attributes>
        </div>
        <div>
            <v-card-title class="py-4 subtitle-2 ">{{$t('descriptionRu')}}</v-card-title>
            <ckeditor
                    :editor="editor"
                    v-model="descriptionRu"
                    :config="editorConfig"
                    class="border-transparent"
                    :rules="rules"
                    required
            ></ckeditor>
        </div>
        <div class="pb-2">
            <v-card-title class="py-4  subtitle-2 ">{{$t('descriptionUa')}}</v-card-title>
            <ckeditor
                :editor="editor"
                v-model="descriptionUa"
                :config="editorConfig"
                class="border-transparent"
                :rules="rules"
                required
            ></ckeditor>
        </div>
    </v-card>
        <div class="d-flex justify-space-between">
            <v-btn
                    @click="onBack"
                    outlined
                    dark
                    class="caption text--main-yellow "
                    justify="center"
                    width="130"
            >{{$t('back')}}</v-btn>
            <v-btn
                depressed
                class="caption white--text main--yellow"
                width="130"
                :disabled="!characteristicsStep"
                @click="validate"
            >{{$t('save')}}</v-btn>
        </div>
    </v-form>
</template>

<script>
    import './product-add.scss'

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import UploadAdapter from "../../../../plugins/ckeditor-upload-adapter/UploadAdapter"
    import '@ckeditor/ckeditor5-build-classic/build/translations/ru';

    import AuthService from "../../../../app-front/services/api/AuthService"

    import ProductAttributes from './ProductAttribute';
    import ProductUpdateInitial from '../../../../app-front/mixins/ProductUpdateInitial';

    export default {
        name: "CharacteristicsStep",
        props: ['productAttributes'],
        mixins:[ProductUpdateInitial],
        components:{ProductAttributes},
        data() {
            return {
                steps: 2,
                characteristicsStep: false,
                rules: [value => !!value || this.$t('requiredField')],
                editor: ClassicEditor,
                descriptionRu: '',
                descriptionUa: '',
                editorConfig: {
                    language: 'ru',
                    label: this.$t('description'),
                    extraPlugins: [this.uploadAdapter],
                },
                characteristics: [],
                characteristicsData: {},
            }
        },
        methods: {
            attributesChange(data) {
                this.characteristicsData = {
                    enumAttributes: this.getEnumAttributes(data),
                    numericAttributes: this.getNumericAttributes(data),
                    subEnumAttributes: data.subEnumAttributes,
                };
            },
            getEnumAttributes(data) {
                if(!data.enumAttributes)
                    return [];

                const values = Object.values(data.enumAttributes);
                const result = [];
                values.forEach(value => {
                    if (!value) {
                        return;
                    }
                    if (Array.isArray(value)) {
                        value.forEach(item => {
                            result.push(item);
                        })
                    } else {
                        result.push(value);
                    }
                });

                return result;
            },
            getNumericAttributes(data) {
                if(!data.numericAttributes && !data.numericEnum)
                    return [];
                const resultSimple = data.numericAttributes || [];
                const resultEnum = [];
                const valuesEnum = Object.values(data.numericEnum)

                valuesEnum.forEach(item => {
                    item.forEach(itemValue => {
                        const {attributeID, unitID, valueID, value, minValue, maxValue} = itemValue;
                        resultEnum.push({
                            attributeID,
                            unitID,
                            valueID,
                            value,
                            minValue,
                            maxValue,
                        });
                    })
                });

                return [...resultSimple, ...resultEnum];
            },
            onBack() {
                this.$emit('back');
            },
            remove(item) {
                const index = this.selectItems.indexOf(item);
                if (index >= 0) this.selectItems.splice(index, 1)
            },
            setInitialData() {
                this.setAttributes();
                this.setDescription();
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.$emit('validated', {
                        descriptionRu: this.descriptionRu,
                        descriptionUa: this.descriptionUa,
                        attributes: this.characteristicsData,
                    })
                }
            },
            uploadAdapter(editor)
            {
                const options = {
                    uploadUrl: '/api/upload-description-images',
                    headers: {...AuthService.getAuthHeader()}
                };

                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader, options );
                };
            },
        },
    }
</script>

<style scoped>

</style>
